<template>
    <a-config-provider :locale="locale">
        <router-view></router-view>
    </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
    data() {
        return {
            locale: zhCN
        }
    },
    created() {
        let token = localStorage.getItem('cangjie_token')
        if (!token) {
            return this.$router.push('/login')
        }
    }
}
</script>
<style>
</style>
